export default {
  /*
   * index() lista las sublíneas
   */
  index(params) {
    return Vue.http.get('topology/sublines', {params}).then(response => response.data)
  }
}
